import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { ConfigurationService } from './configuration/configuration.service';
import {hideSpinner, markBodyConfigurationReady} from '../../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationGuard implements CanActivate {

  constructor(private _configuration: ConfigurationService) {

  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this._configuration.initializingConfiguration.then(() => {
      this._configuration.initApplicationContext();
      hideSpinner();
      markBodyConfigurationReady();
      return true;

    })
    .catch(() => {
      this._configuration.initApplicationContext();
      hideSpinner();
      return false;
    });
  }
}
